/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ReadyMadePosts.scss";
import {
  trackSession,
  updateMode,
  setReadyMade,
  setCategory,
  filterPosts,
  setCategories,
  filterCategoriesByID,
  setDefaultCategory,
  updatePlatform,
} from "../../actions";
import { Dimmer, Loader } from "semantic-ui-react";
import PostCard from "../PostCard/PostCard";
import Navbar from "../Navbar/Navbar";
import { useMediaQuery } from "react-responsive";
import NotFound from "../404Page/NotFound";
import Carousel from "react-elastic-carousel";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import { setCategoryClick } from "../utils/Amplitude";
import axios from "axios";
import { getPlatformColor } from "../utils/sharing";
import axiosRetry from "axios-retry";
import { useResizeDetector } from "react-resize-detector";
import Footer from "../Footer/Footer";
import { i18nKeys, I18n } from "../utils/functions";

axiosRetry(axios, { retries: 3, retryCondition: (_error) => true });

const ReadyMadePosts = (props) => {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.sharer);
  const campaignId = props.match.params.campaignId;
  const [defaultCategories, setDefaultCategories] = useState();
  const postsRef = useRef(null);
  const categoriesRef = useRef(null);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const value = urlParams.get("v");
  const url = urlParams.get("url");
  const [nativeWebShareAPI, setNativeWebShareAPI] = useState(null);
  const userAgent = navigator.userAgent;
  const [os, setOS] = useState();
  const [scalingFactor, setScalingFactor] = useState(1.0);
  const autoScaleIframe = useRef(false);
  const [resizeCnt, setResizeCnt] = useState(0);

  const i18n = new I18n();

  useEffect(() => {
    autoScaleIframe.current = state.wp && !state.multirow;
  }, [state.multirow, state.wp]);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 901 });
    return isDesktop ? children : null;
  };

  const Tablet = ({ children }) => {
    const isDesktop = useMediaQuery({ maxWidth: 900 });
    return isDesktop ? children : null;
  };

  useEffect(() => {
    dispatch(updateMode("Ready Made Post"));
    const platform = props.match.params.platform.split("?")[0];
    dispatch(updatePlatform(platform));
  }, [dispatch]);

  const checkNavigator = async () => {
    if (typeof navigator.canShare === "function") {
      const response = await axios.get(
        "https://pic.speechifai.tech/A00AF1A5-0E90-4997-88D2-D8D91137DB11.jpg",
        { responseType: "blob" }
      );
      const blob = await response.data;
      const filesArray = [
        new File([blob], "dummy.jpg", {
          type: "image/jpeg",
          lastModified: new Date().getTime(),
        }),
      ];
      const shareData = {
        files: filesArray,
      };
      if (navigator.canShare(shareData)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const onResize = useCallback(() => {
    setResizeCnt((prev) => prev+1);   
  }, []);
  const { width, height, ref } = useResizeDetector({
    onResize,
    refreshMode: "throttle",
    refreshRate: 100,
    refreshOptions: { leading: false, trailing: true }
  });
  
 
  useEffect(() => {
    checkNavigator().then((res) => {
      setNativeWebShareAPI(res);
    });

    // SET OS
    if (/windows phone/i.test(userAgent)) {
      setOS("Windows Phone");
    } else if (/android/i.test(userAgent)) {
      setOS("Android");
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return setOS("IOS");
    } else {
      setOS("unknown");
    }

    // Gleam for NCSU
    if(campaignId === "93337B20-3592-4FF9-B4A3-0226DFE4FD4E") {
      const g = document.createElement("script");
      const s = document.getElementsByTagName("script")[0];
      g.src = "https://js.gleam.io/TNZbb/trk.js";
      g.async = true;
      g.onload = () => {
        const script = document.createElement("script");
        script.src = "/static/lib/gleam.js";
        script.async = true;
        s.parentNode.insertBefore(script, s);  
      };
      s.parentNode.insertBefore(g, s);
    }
  }, []);

  const embeddingBackgroundColor = () => {
    let color = 'white';
    if (state.wp) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const bgcolor = urlParams.get("bgcolor");
      color = bgcolor;
    }
    return color;
  };

  useEffect(() => {
    // Transparent background for web embed
    if (state.wp && !state.multirow) {
      if (state.categories.length <= 1 || state.categoryID !== null) {
        document.body.style.backgroundColor = "transparent";
        document.body.style.background = "transparent";
      } else {
        document.body.style.backgroundColor = embeddingBackgroundColor();
        document.body.style.background = embeddingBackgroundColor();
      }
    } else {
      document.body.style.backgroundColor = embeddingBackgroundColor();
      document.body.style.background = embeddingBackgroundColor();
    }
  }, [state.wp, state.categories, state.categoryID]);

  useEffect(() => {
    if (state.platform.length > 0) {
      dispatch(setReadyMade(campaignId, state.platform, state.apiMode)).then(
        async (res) => {
          if (res.categories && res.campaign) {
            const defaultCategoryText = res.campaign.defaultCategoryText;
            const hideAllPostsCategory = res.campaign.hideAllPostsCategory;

            const tempCategories = [];
            res.readyMadePosts.map((post) => {
              if (!post.optCat.hasOwnProperty("category")) {
                post.optCat = { category: { id: "NO CATEGORY" } };
              }
              const newCategories = res.availableCategories.filter(
                (category) => category.id === post.optCat.category.id
              );
              for (let i = 0; i < newCategories.length; i++) {
                tempCategories.push(newCategories[i]);
              }
              return;
            });

            const uniqueCategories = [...new Set(tempCategories)];

            dispatch(setCategories(uniqueCategories)).then((res) => {
              if (hideAllPostsCategory === true) {
                dispatch(filterCategoriesByID(state.categoryID));
              } else if (hideAllPostsCategory === null || undefined) {
                dispatch(filterCategoriesByID(state.categoryID));
              } else {
                dispatch(
                  setDefaultCategory(
                    defaultCategoryText
                      ? { name: defaultCategoryText, id: 0 }
                      : { name: "All Posts", id: 0 },
                    res
                  )
                ).then((res) => {
                  setDefaultCategories(res);
                });
                dispatch(filterCategoriesByID(state.categoryID));
              }
            });
          }
        }
      );
      dispatch(
        trackSession({ campaignID: campaignId, wp: state.wp }, state.apiMode)
      );
    }
  }, [state.platform]);

  const goToCategory = (category, id, index) => {
    filterCategory(category, id).then((res) => {
      categoriesRef.current.goTo(index);
    });
    setCategoryClick({ Category: category });
  };

  const filterCategory = (category, id) => {
    dispatch(setCategory(category));
    dispatch(filterPosts(id));

    return Promise.resolve();
  };

  useEffect(() => {
    if (state.filteredCategory) {
      filterCategory(state.filteredCategory.name, state.filteredCategory.id);
    }
  }, [state.filteredCategory]);

  useEffect(() => {
    if (state.filteredCategory) {
      dispatch(setCategory(state.filteredCategory.name));
      dispatch(filterPosts(state.filteredCategory.id));
    } else {
      if (defaultCategories && defaultCategories.length > 1) {
        dispatch(setCategory(defaultCategories[0].name));
        dispatch(filterPosts(defaultCategories[0].id));
      } else if (state.categories && state.categories.length > 1) {
        dispatch(setCategory(state.categories[0].name));
        dispatch(filterPosts(state.categories[0].id));
      }
    }
  }, [defaultCategories, state.categories]);

  const isSmallScreen = useMediaQuery({ maxWidth: 600 });
  const isMediumScreen = useMediaQuery({ maxWidth: 960 });
  const isLargeScreen = useMediaQuery({ maxWidth: 1460 });

  const numEmbeddedPosts = isSmallScreen ? 1 :
                         isMediumScreen ? 2 :
                         isLargeScreen ? 3 : 4;
                            
  const renderCarouselPage = (paginationProps) => {
    const pages = paginationProps.pages;
    const activePage = paginationProps.activePage;
    const onClick = paginationProps.onClick;

    return (
      <div>
        {pages.map((page) => {
          const numPages = pages.length;
          const isActivePage = activePage === page;
          const isHiddenPage = (Math.abs(page - activePage) > 3) && (
                                (activePage < page && page >= 6) ||
                                (activePage > page && page < numPages-6));
          const isSmallPage = (Math.abs(page - activePage) > 2) && (
                                (activePage < page && page >= 5) ||
                                (activePage > page && page < numPages-5));
          return (
            <span
              className={
                isHiddenPage
                  ? "dot dot_hidden"
                  : isActivePage
                  ? "dot dot_active"
                  : isSmallPage
                  ? "dot dot_small"
                  : "dot"
              }
              key={page}
              onClick={() => onClick(page)}
              active={isActivePage}
            ></span>
          );
        })}
      </div>
    );
  };

  const createPostCard = (post) => {
    return <PostCard 
              image={post.imageContext.image}
              socialNetwork={post.readyMadePost.socialNetwork}
              linkCaption={post.readyMadePost.linkCaption ? post.readyMadePost.linkCaption : state.readyMadeData.campaign.facebookTitle}
              hashtags={post.readyMadePost.hashtags}
              link={post.readyMadePost.link}
              text={post.readyMadePost.text}
              campaignID={post.readyMadePost.campaignID}
              key={post.readyMadePost.superEntity}
              share={
                state.readyMadeData.whitelabel &&
                state.readyMadeData.whitelabel
                  .sharingPageCustomizeShare
              }
              optimizeTweet={
                state.readyMadeData.campaign
                  .showOptimizeTweetButton
              }
              id={post.readyMadePost.id}
              url={
                props.location.state &&
                props.location.state.url
                  ? props.location.state.url
                  : url
              }
              value={
                props.location.state &&
                props.location.state.value
                  ? props.location.state.value
                  : value
              }
              modalTitle={
                state.readyMadeData.whitelabel &&
                state.readyMadeData.whitelabel
                  .customizeAndShareDialogHeaderTitle
              }
              modalButton={
                state.readyMadeData.whitelabel &&
                state.readyMadeData.whitelabel
                  .customizeAndShareDialogButtonTitlePrefix
              }
              modalPaste={
                state.readyMadeData.whitelabel &&
                state.readyMadeData.whitelabel
                  .pleasePasteAfterContinuing
              }
              postAmount={state.filteredPosts.length}
              deviceInfo={{
                nativeSharingAvailable: nativeWebShareAPI,
                os: os,
              }}
              editing={post.editing}
              resolvedMedia={post.readyMadePost.resolvedMedia}
              resizeTrigger={resizeCnt}
            />;
  };

  return (
    <>
      {state.error ? (
        <NotFound />
      ) : (
        <>
          {(!state.readyMadeData) ? (
            <div className="home-loader">
              <Dimmer
                active
                inverted
                style={{ backgroundColor: "transparent" }}
              >
                <Loader inverted>
                  {i18n.getText(i18nKeys.loadingPosts)}
                </Loader>
              </Dimmer>
            </div>
          ) : (
            <div
              ref={ref}
              className={"ready-made-container"}
              id="ready-made-container"
              style={{
                "--display-size":
                  (scalingFactor * 100.0).toFixed(2).toString() + "%",
                "--display-size-inverted":
                  ((1 / scalingFactor) * 100.0).toFixed(2).toString() + "%",
              }}
            >
              <div
                className={
                  state.wp
                    ? "ready-made-wrapper-embedded"
                    : "ready-made-wrapper"
                }
              >
                <MetaTags>
                  <title>
                    {state.readyMadeData && state.readyMadeData.whitelabel
                      ? `${state.readyMadeData.campaign.name} | ${state.readyMadeData.whitelabel.headTitle}`
                      : state.readyMadeData.campaign.name}
                  </title>
                </MetaTags>
                <Favicon
                  url={
                    state.readyMadeData.whitelabel &&
                    state.readyMadeData.whitelabel.faviconURL
                      ? state.readyMadeData.whitelabel.faviconURL
                      : "https://pic.speechifai.tech/F9E45BF4-38BE-4FFF-9740-BCC99D681563.jpg"
                  }
                />

                <div
                  className="navbar-container"
                >                
                <Navbar
                  socialNetworks={
                    state.readyMadeData.metadata
                      .supportedReadyMadeSocialNetworks
                  }
                  campaignID={campaignId}
                />

                {(!state.fetchingReadyMade) && (
                  <>
                  {state.filteredCategory ? (
                    <></>
                  ) : (
                    <>
                      <Desktop>
                        {state.categories &&
                          state.categories.length > 1 &&
                          state.readyMadeData.campaign && (
                            <div
                              className={
                                state.wp
                                  ? "posts-categories-embedded cat-box-shadow"
                                  : "posts-categories cat-box-shadow"
                              }
                              style={{"background": state.wp ? embeddingBackgroundColor() : "white"}}
                              data-cy="ready-categories"
                            >
                              <Carousel
                                ref={categoriesRef}
                                itemsToShow={6}
                                itemsToScroll={2}
                                focusOnSelect={true}
                                preventDefaultTouchmoveEvent={true}
                                pagination={false}
                                itemPosition="flex-start"
                                className={"category-carousel"}
                              >
                                {state.categories.map((category, index) => (
                                  <span
                                    className={
                                      state.categories.length > 2
                                        ? "category-trim"
                                        : ""
                                    }
                                    key={category.id}
                                  >
                                    <p
                                      className={
                                        state.activeCategory === category.name
                                          ? `category-active`
                                          : "category"
                                      }
                                      onClick={() => {
                                        goToCategory(
                                          category.name,
                                          category.id,
                                          index
                                        );
                                        if(postsRef && postsRef.current) {
                                            postsRef.current.goTo(0);
                                          }
                                      }}
                                      style={{
                                        "--platform_color": getPlatformColor(
                                          state.platform
                                        ),
                                      }}
                                    >
                                      {category.name}
                                    </p>
                                  </span>
                                ))}
                              </Carousel>
                            </div>
                          )}
                      </Desktop>
                      <Tablet>
                        {state.categories &&
                          state.categories.length > 1 &&
                          state.readyMadeData.campaign && (
                            <div
                              className={
                                state.wp
                                  ? "posts-categories-embedded cat-box-shadow"
                                  : "posts-categories cat-box-shadow"
                              }
                              data-cy="ready-categories"
                            >
                              <Carousel
                                ref={categoriesRef}
                                itemsToShow={2}
                                itemsToScroll={2}
                                focusOnSelect={true}
                                pagination={false}
                                className="category-carousel"
                              >
                                {state.categories.map((category, index) => (
                                  <p
                                    className={
                                      state.activeCategory === category.name
                                        ? `category-active`
                                        : "category"
                                    }
                                    onClick={() => {
                                      goToCategory(
                                        category.name,
                                        category.id,
                                        index
                                      );
                                      if(postsRef && postsRef.current) {
                                        postsRef.current.goTo(0);
                                      }
                                    }}
                                    key={category.id}
                                    style={{
                                      "--platform_color": getPlatformColor(
                                        state.platform
                                      ),
                                    }}
                                  >
                                    {category.name}
                                  </p>
                                ))}
                              </Carousel>
                            </div>
                          )}
                      </Tablet>
                    </>
                  )}
                  </>
                )}
                </div>

                {(state.fetchingReadyMade) ? (
                  <div className="home-loader">
                    <Dimmer
                      active
                      inverted
                      style={{ backgroundColor: "transparent" }}
                    >
                      <Loader inverted>
                        {i18n.getText(i18nKeys.loadingPosts)}
                      </Loader>
                    </Dimmer>
                  </div>
                ) : (
                  <div className="flex-column posts-container embedded-posts-container">
                    {state.wp && !state.multirow ? (
                      state.filteredPosts && state.filteredPosts.length === 1 ? (
                        <>
                        <div className="single-post-embedding">
                        {state.filteredPosts.map((post) => (
                            createPostCard(post)
                          ))}
                          </div>
                        </>
                      ) : (
                      <Carousel
                        ref={postsRef}
                        itemsToShow={numEmbeddedPosts}
                        itemsToScroll={numEmbeddedPosts}
                        itemPadding={[0, 0, 0, 0]}
                        outerSpacing={0}
                        className={`post-carousel 
                                    embedded-${numEmbeddedPosts === 1 ? "mobile" :
                                    numEmbeddedPosts === 2 ? "tablet" : "desktop"}`}
                        pagination={
                          state.filteredPosts.length <= numEmbeddedPosts ? false : true
                        }
                        preventDefaultTouchmoveEvent={numEmbeddedPosts >= 3 ? true : undefined}
                        renderPagination={renderCarouselPage}
                      >
                        {state.filteredPosts &&
                          state.filteredPosts.map((post) => (
                            createPostCard(post)
                          ))}
                      </Carousel>
                      )
                    ) : (
                      <div className="posts-posts">
                        {state.filteredPosts &&
                          state.filteredPosts.map((post) => (
                            createPostCard(post)
                          ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {(!state.wp && !state.fetchingReadyMade) ? <Footer {...state.readyMadeData} /> : null}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(ReadyMadePosts);
